<template>
  <section class="sec" id="honors">
    <div class="sec-inner">
      <div class="sec-head">
        <div class="sec-eyebrow">荣誉</div>
        <h2 class="sec-title">所获荣誉</h2>
        <p class="sec-sub">
          三项国家医保局主办的全国性赛事成绩，以及技术社区、从业与求学阶段获得的认可。
        </p>
      </div>

      <div class="honor-list">
        <div class="honor" v-for="h in honors" :key="h.year + h.award">
          <div class="honor-year">
            <div class="hy-num">{{ h.year }}</div>
            <div class="hy-date" v-if="h.date">{{ h.date }}</div>
          </div>

          <div class="honor-main">
            <div class="honor-top">
              <span class="honor-award" :class="'lv-' + h.level">
                {{ h.award }}
              </span>
              <h3 class="honor-title">{{ h.title }}</h3>
            </div>
            <div class="honor-meta" v-if="h.track || h.org">
              <span v-if="h.track">{{ h.track }}</span>
              <span v-if="h.org" class="honor-org">{{ h.org }}</span>
            </div>
            <p class="honor-desc" v-if="h.desc">{{ h.desc }}</p>

            <div class="honor-imgs" v-if="h.images.length" data-zoom-group>
              <div class="honor-img" v-for="img in h.images" :key="img.src">
                <img :src="img.src" :alt="img.alt" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { honors } from "@/assets/js/profile";

export default {
  name: "HonorSection",
  data() {
    return { honors };
  }
};
</script>

<style scoped>
.sec-head {
  margin-bottom: 40px;
}
.honor-list {
  border-top: 1px solid var(--border);
}
.honor {
  display: flex;
  flex-wrap: wrap;
  padding: 30px 0;
  border-bottom: 1px solid var(--border);
}
.honor-year {
  flex: 0 0 160px;
  padding-right: 24px;
}
.hy-num {
  font-size: 22px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.4px;
}
.hy-date {
  font-size: 12.5px;
  color: var(--ink-faint);
  margin-top: 5px;
}
.honor-main {
  flex: 1 1 420px;
  min-width: 280px;
}
.honor-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 9px;
}
.honor-award {
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  padding: 4px 11px;
  margin-right: 12px;
}
.lv-national {
  color: var(--on-accent);
  background: var(--accent);
}
.lv-work {
  color: var(--accent-deep);
  background: var(--accent-wash);
}
.lv-personal {
  color: #7a5f38;
  background: #f2ead9;
}
.lv-school {
  color: var(--ink-mid);
  background: var(--bg-alt);
  border: 1px solid var(--border);
}
/* 社区/平台认证（CSDN、极星会） */
.lv-community {
  color: #47617d;
  background: #e7edf3;
}
.honor-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--ink);
  margin: 0;
  letter-spacing: -0.2px;
}
.honor-meta {
  font-size: 13.5px;
  color: var(--ink-soft);
  margin-bottom: 8px;
}
.honor-meta span {
  margin-right: 14px;
}
.honor-org {
  color: var(--ink-faint);
}
.honor-desc {
  font-size: 14.5px;
  line-height: 1.9;
  color: var(--ink-soft);
  margin: 0;
}
.honor-imgs {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
}
.honor-img {
  display: block;
  cursor: zoom-in;
  width: 168px;
  height: 118px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  margin: 0 12px 12px 0;
  background: var(--bg-card);
  transition: border-color 0.18s ease;
}
.honor-img:hover {
  border-color: var(--accent);
}
.honor-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (max-width: 760px) {
  .honor-year {
    flex: 0 0 100%;
    padding-right: 0;
    margin-bottom: 10px;
  }
  .hy-num {
    font-size: 18px;
  }
  .honor-title {
    font-size: 16px;
  }
  .honor-img {
    width: 132px;
    height: 94px;
  }
}
</style>
